export const buildUrlWithParams = (
    url: string,
    params: object = {},
): string => {
    const query = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            query.append(key, String(value));
        }
    });

    const queryString = query.toString();
    return queryString ? `${url}?${queryString}` : url;
};
